import { useCallback, useEffect, useState } from "react";

import { getWorkspace } from "@/components/QuickSearch/utils/mainWorkspace";
import { getBoards } from "@/services/monday-service";
import type { Board } from "@/types/common";
const LIMIT = 25;

export function useQueryItemsForBoards() {
  const [loading, setLoading] = useState(true);
  const [hasMore, setHasMore] = useState(false);
  const [boards, setBoards] = useState<Board[]>([]);
  const [page, setPage] = useState(1);

  const filterBoards = (boards: Board[]) => boards.filter((item) => item.type === "board");

  const transformBoards = (boards: Board[]): Board[] => {
    return boards.map(({ workspace, ...item }) => ({ ...item, workspace: getWorkspace(workspace) }));
  };

  const loadNextPage = useCallback(() => {
    setPage((prev) => prev + 1);
  }, []);

  useEffect(() => {
    setLoading(true);
    getBoards(LIMIT, page)
      .then((response) => {
        const curBoards = transformBoards(filterBoards(response));
        setBoards((prevBoards) => [...prevBoards, ...curBoards]);
        setHasMore(curBoards.length > 0);
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  }, [page]);
  return { loading, boards, hasMore, loadNextPage };
}
